import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useKozelMeetStyles = createUseStyles((theme: Theme) => {
        return {
            container: {
                justifyContent: 'center',
                backgroundColor: theme.colors.dark_chocolate,
            }
        }
    }
)

export default useKozelMeetStyles;